import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const ReviewSectionStyleDiv = styled.div`
    margin-top: 1.5em;
`;

export const ReviewSectionStyle = ({ children }) => {
    return <ReviewSectionStyleDiv className="review-section">{children}</ReviewSectionStyleDiv>;
};

ReviewSectionStyle.propTypes = {
    children: PropTypes.node.isRequired,
};
